/* Custom Club: small fixes on top of the theme's global.js */
(function () {
  var orig = window.formatPrice;
  if (typeof orig !== 'function') return;
  window.formatPrice = function (amount, moneyString) {
    if (amount != null && typeof moneyString === 'string' && /\{\{\s*amount_with_comma_separator\s*\}\}/.test(moneyString)) {
      var parts = (parseFloat(amount) / 100).toFixed(2).split('.');
      var value = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
      return moneyString.replace(/\{\{.*?\}\}/, value);
    }
    return orig.apply(this, arguments);
  };
})();

/* What counts towards free shipping / the Mystery Piece: items after bundle discounts and after
   discount codes (VIP15 etc.), without the gift line and without the Mystery discount itself.
   Percentage codes are applied to the non-gift items only, so adding the gift never pushes the
   cart back under the threshold. Also used by the product page bar (cos-pdp-extras). */
window.ccRewardTotal = function (cart) {
  var items = 0;
  (cart.items || []).forEach(function (i) { if (!(i.properties && i.properties._free_gift)) items += i.final_line_price; });
  var total = items;
  (cart.cart_level_discount_applications || []).forEach(function (d) {
    if (/mystery/i.test(d.title || '')) return;
    if (d.value_type === 'percentage') total -= Math.round(items * parseFloat(d.value) / 100);
    else total -= d.total_allocated_amount || 0;
  });
  return Math.max(0, total);
};

/* Gift/shipping progress: same body as global.js, but the reward total comes from ccRewardTotal. */
if (typeof window.syncFreeGift === 'function' && window.theme && window.theme.settings) {
window.updateFreeShipping = async function updateFreeShipping() {
  const conversionRate = Shopify.currency.rate;
  const {
    cart_free_shipping_enabled: freeShippingEnabled,
    cart_free_shipping_text: freeShippingTextDefault,
    cart_free_shipping_text_success: freeShippingTextSuccessDefault,
    cart_free_shipping_threshold: freeShippingThreshold,
    cart_free_gift_enabled: freeGiftEnabled,
    cart_free_gift_threshold: freeGiftThreshold,
    cart_free_gift_text: freeGiftTextDefault,
    cart_free_gift_text_success: freeGiftTextSuccessDefault,
    cart_free_shipping_and_gift_text_success: allUnlockedTextSuccessDefault,
    money_format: moneyFormat
  } = window.theme.settings;

  const freeShippingElements = document.querySelectorAll("shipping-bar");

  try {
    const response = await fetch("/cart.js");
    const cart = await response.json();
    const { items_subtotal_price, item_count } = cart;

    const giftItem = cart.items.find(item => item.properties && item.properties._free_gift);
    // the gift's own price never counts towards unlocking rewards; discount codes do, the Mystery discount doesn't
    const rewardTotal = window.ccRewardTotal(cart);

    const visibility = item_count == 0 ? "hidden" : "visible";
    freeShippingElements.forEach(
      el => (el.style.visibility = visibility)
    );

    const shippingActive = freeShippingEnabled && freeShippingThreshold > 0;
    const giftActive = freeGiftEnabled && freeGiftThreshold > 0;

    const newShippingThreshold = Math.round(freeShippingThreshold * conversionRate);
    const newGiftThreshold = Math.round(freeGiftThreshold * conversionRate);
    const maxThreshold = Math.max(
      shippingActive ? newShippingThreshold : 0,
      giftActive ? newGiftThreshold : 0
    );

    const shippingUnlocked = shippingActive && rewardTotal >= newShippingThreshold;
    const giftUnlocked = giftActive && rewardTotal >= newGiftThreshold;

    // message for the closest locked milestone, or a success message
    let message;
    const lockedMilestones = [];
    if (shippingActive && !shippingUnlocked) {
      lockedMilestones.push({
        threshold: newShippingThreshold,
        text: fillRemainingAmount(freeShippingTextDefault, newShippingThreshold - rewardTotal, moneyFormat)
      });
    }
    if (giftActive && !giftUnlocked) {
      lockedMilestones.push({
        threshold: newGiftThreshold,
        text: fillRemainingAmount(freeGiftTextDefault, newGiftThreshold - rewardTotal, moneyFormat)
      });
    }

    if (lockedMilestones.length > 0) {
      lockedMilestones.sort((a, b) => a.threshold - b.threshold);
      message = lockedMilestones[0].text;
      // shipping already reached: keep showing it as unlocked, then the next goal
      if (shippingUnlocked && giftActive && !giftUnlocked) {
        var de = /^de/i.test(document.documentElement.lang || '');
        message = '<strong class="cc-unlocked">' + (de ? 'Gratisversand freigeschaltet' : 'Free shipping unlocked') + ' ✓</strong><br>' + message;
      }
    } else if (shippingUnlocked && giftUnlocked) {
      message = allUnlockedTextSuccessDefault;
    } else if (giftUnlocked) {
      message = freeGiftTextSuccessDefault;
    } else {
      message = freeShippingTextSuccessDefault;
    }

    freeShippingElements.forEach(freeShipping => {
      const freeShippingTextElement = freeShipping.querySelector(".progress-bar__text");
      const progressBarInner = freeShipping.querySelector("[data-progress-line]");

      freeShippingTextElement.innerHTML = message;

      if (maxThreshold > 0 && rewardTotal < maxThreshold) {
        progressBarInner.style.width = `calc(${(rewardTotal / maxThreshold) * 100}% + 2px)`;
      } else {
        progressBarInner.style.width = "100%";
      }

      const shippingMilestone = freeShipping.querySelector('[data-milestone="shipping"]');
      const giftMilestone = freeShipping.querySelector('[data-milestone="gift"]');
      if (shippingMilestone) {
        // short pop the moment free shipping gets unlocked
        if (shippingUnlocked && freeShipping.dataset.ccShip === '0') {
          shippingMilestone.classList.remove('cc-pop'); void shippingMilestone.offsetWidth; shippingMilestone.classList.add('cc-pop');
        }
        freeShipping.dataset.ccShip = shippingUnlocked ? '1' : '0';
        shippingMilestone.classList.toggle("is-reached", shippingUnlocked);
      }
      if (giftMilestone) giftMilestone.classList.toggle("is-reached", giftUnlocked);
    });

    if (giftActive) {
      await syncFreeGift({ giftItem, giftUnlocked, itemCount: item_count });
    }
  } catch (error) {
    console.error("Error fetching cart data:", error);
  }
};
  if (document.querySelector('shipping-bar')) window.updateFreeShipping();
  (function () {
    var st = document.createElement('style');
    st.textContent = '.progress-bar__text .cc-unlocked{font-weight:600;color:#080808}' +
      '@keyframes ccPop{0%{transform:scale(1)}40%{transform:scale(1.35)}100%{transform:scale(1)}}' +
      '.progress-bar__milestone.cc-pop{animation:ccPop .6s ease}';
    document.head.appendChild(st);
  })();
}
